<div class="loader">
    <img class="animate-spin" src="assets/images/loader.png" alt="Loader">
  </div>